import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { PropertyService } from '../../../services/property.service';
import { PropertyInitialSubject } from '../../../subject/property.initial.subject';
import { PropertySearchMapper } from '../../../mappers/property-search.mapper';
import { PropertySearchCardVM } from '../../../models/property-search-card.vm';
import { FlowMode } from '../../../dto/enum/flow.mode.enum';
import { FlowModeSubject } from '../../../subject/flow.mode.subject';

/**
 * Pantalla "¡Listo! Es hora de publicar." — preview de lo que verá el público + qué sigue.
 * Se llega desde /ad "Concluir registro" (que ya marcó la propiedad COMPLETED_PROP), por eso
 * acá ya se puede traer con el shape de card real. "Siguiente" → /success.
 */
@Component({
  selector: 'app-property-review',
  templateUrl: './property-review.component.html',
  styleUrls: ['./property-review.component.scss']
})
export class PropertyReviewComponent implements OnInit {

  propertyId?: number;
  segmentLabel = 'propiedad';
  cardVm: PropertySearchCardVM | null = null;
  loading = true;

  currentMode: FlowMode = FlowMode.CREATE;
  previousUrl = '/ad';
  nextUrl = '/success';

  constructor(
    private router: Router,
    private propertyService: PropertyService,
    private propertyInitialSubject: PropertyInitialSubject,
    private cardMapper: PropertySearchMapper,
    private flowModeSubject: FlowModeSubject
  ) {}

  ngOnInit(): void {
    this.currentMode = this.flowModeSubject.getCurrentMode() || FlowMode.CREATE;
    const property = this.propertyInitialSubject.getCurrentProperty();
    this.propertyId = property?.propertyId;
    this.segmentLabel = property?.segmentLabel || 'propiedad';
    if (!this.propertyId) { this.loading = false; return; }

    this.propertyService.getDetailProperty(this.propertyId).pipe(
      catchError(() => of(null))
    ).subscribe((dto: any) => {
      this.cardVm = dto ? this.cardMapper.toCardVM(dto) : null;
      this.loading = false;
    });
  }

  previewProperty(propertyId: number): void { this.router.navigate(['/property', propertyId]); }
  handleNextStep(): void { this.router.navigate([this.nextUrl]); }
  handlePreviousStep(): void { this.router.navigate([this.previousUrl]); }
  handleSaveAndExit(): void { this.router.navigate(['/list-pending']); }
}
